import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppDataServiceService} from 'src/app/app-data-service.service'
@Injectable({
  providedIn: 'root'
})
export class LeftThoughRightService {
 private _baseUrl:string = "http://50.62.22.142/api";
  constructor(
    private http : HttpClient,
    private globalDate : AppDataServiceService
    ) { }
   public  year;
   public month;
   public day;
   public liveDate;
   public  dataAll:any = [];
   //----------energy ---------------------------------
    
   
   getEnergyAllChartData(data,date){   
    return  this.http.get(`${this._baseUrl}/energy/groups_energy/${data.group_id}@${date}`);
    }

    getDailyEnergy(data){
      this.year = data.year;
      this.month = data.month_no
      return  this.http.get(`${this._baseUrl}/energy/groups_energy/${data.group_id}/${data.year}/${data.month_no}`);
    }  

    getHourlyEnergy(data){
      console.log(data)
      let date = new Date(data.date)
      return  this.http.get(`${this._baseUrl}/energy/groups_energy/${data.group_id}/${date.getFullYear()}/${date.getMonth()+1}/${data.day_no}`);
    }  

    getDeviceDailyEnergy(data){
      console.log(data)
      return  this.http.get(`${this._baseUrl}/energy/device/${data.group_id}/${data.year}/${data.month_no}`);
    }  

    getDeviceHourlyEnergy(data){
      let date = new Date(data.date)
      return  this.http.get(`${this._baseUrl}/energy/device/${data.group_id}/${date.getFullYear()}/${date.getMonth()+1}/${data.day_no}`);
    } 

    getDeviceEnergyAllChartData(data){
      this.globalDate.globalDate.subscribe(res=> this.liveDate = res);
    return  this.http.get(`${this._baseUrl}/energy/device/${data.group_id}@${this.liveDate}`);
    }

 //----------production ---------------------------------

    getProductivityAllChartData(data){
      this.globalDate.globalDate.subscribe(res=> this.liveDate = res);
    return  this.http.get(`${this._baseUrl}/productivity/production/${data.name}@${this.liveDate}`);
    }

  getDailyProduction(data){
    console.log(data);
    console.log("hey there");
    return  this.http.get(`${this._baseUrl}/productivity/production/${data.name}/${data.year}/${data.month}`);
  }  

  getHourlyProduction(data){
    console.log(data);
    return  this.http.get(`${this._baseUrl}/productivity/production/${data.name}/${data.year }/${data.month }/${data.day}`);
  }  


  //----------performance-------------------

    getProductionAllChartData(data){

      console.log('getProductionAllChartData',data);
      return  this.http.get(`${this._baseUrl}/productivity/performance/${data.device_id}@${data.date}`);
    }  


  getDailyPerformance(data){
  console.log(data);
    return  this.http.get(`${this._baseUrl}/productivity/performance/${data.name}/${data.year}/${data.month}`);
  }  

  getHourlyPerformance(data){
    console.log(data);
    return  this.http.get(`${this._baseUrl}/productivity/performance/${data.name}/${data.year }/${data.month }/${data.day}`);
  } 
}